import { CheckCircleRounded, CloseRounded } from '@mui/icons-material';
import { IconButton, Stack, Typography } from '@mui/material';
import { StyledBaseSnackbar } from './BaseSnackbar.style';

const vertical = 'top';
const horizontal = 'right';

type TProps = {
  open: boolean;
  handleClose: () => void;
  message: string;
  severity?: 'success' | 'info' | 'warning' | 'error';
};

export const BaseSnackbar = ({
  open,
  message,
  handleClose,
  severity = 'success',
}: TProps) => {
  const action = (
    <>
      <IconButton size="small" aria-label="close" onClick={handleClose}>
        <CloseRounded fontSize="small" />
      </IconButton>
    </>
  );

  return (
    <div>
      <StyledBaseSnackbar
        open={open}
        message={
          <Stack direction="row" spacing={2} alignItems="center">
            {severity === 'success' && (
              <CheckCircleRounded
                color="success"
                sx={{
                  padding: '8px',
                  width: '40px',
                  height: '40px',
                  borderRadius: '12px',
                  backgroundColor: 'rgba(84, 214, 44, 0.16)',
                }}
              />
            )}
            <Typography variant="subtitle2" sx={{ mr: 'auto' }}>
              {message}
            </Typography>
          </Stack>
        }
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={3000}
        action={action}
      />
    </div>
  );
};
